import { Button } from "@mui/material";


interface ConfigButtonsProps {
  areDataFieldsValid: boolean;
  hasActiveChild: boolean;
  handleSave: () => void;
  handleReset: () => void;
  isSpinning: boolean;
  setIsSpinning: React.Dispatch<React.SetStateAction<boolean>>;
}
const ConfigButtons: React.FC<ConfigButtonsProps> = ({
  areDataFieldsValid,
  hasActiveChild,
  handleSave,
  handleReset,
  isSpinning,
  setIsSpinning,
}) => {
  return (
    <div
      className={`config-save-button-container ${
        !areDataFieldsValid ? "custom-cursor-not-allowed" : ""
      }  ${hasActiveChild ? "has-active-child" : ""}`}
    >
      <Button
        disabled={!areDataFieldsValid}
       
        onClick={handleReset}
        sx={{
          alignSelf: "flex-end",
          fontSize: "13px",
          color:"grey",
          padding:"6px 24px",
          border:"0.5px solid grey",
          marginRight:"10px",
          textTransform:"none",
          borderRadius:"8px",
        }}
      >
        Reset
       
      </Button>
      <Button
        disabled={!areDataFieldsValid}
       
        onClick={handleSave}
        sx={{
          alignSelf: "flex-end",
          borderRadius:"8px",
          padding:"6px 24px",
          fontSize: "13px",
          border:"0.5px solid #00C6B1",
           backgroundColor: "#00C6B1",
          color:"#ffffff",
           "&:hover": {
      backgroundColor: "#00C6B1", 
    },
    "&:active": {
      backgroundColor: "#00C6B1",
    },
          textTransform:"none"
        }}
      >
        Save
      </Button>
    </div>
  );
};
export default ConfigButtons;
